const INTERIOR_STOVES = "/images/about-oops-fingers.webp";
const UNIT_RENDER = "/images/about-vegan-burgler.webp";

const TEAM = [
  {
    name: "Curtis Dilworth",
    role: "Founder & Chief Executive Officer",
    bio: "Curtis Dilworth is the pioneer behind the micro commercial development concept and the creator of the PadSite model. He brings multi-decade experience across construction, development, project management, and hospitality. The founder of a family-owned construction firm, he has delivered more than 100 restaurants, bars, nightclubs, and commercial venues. His notable projects include work at Hartsfield-Jackson International Airport, Grady Hospital, Morris Brown College, and Morehouse College. Curtis holds a B.S. in Business Economics from Auburn University. At PadSite, he leverages his visionary background to guide corporate strategy, development, and the expansion of the company’s modular commercial real estate platform.",
  },
  {
    name: "Isaac Brown",
    role: "Chief Development Officer",
    bio: "Isaac Brown oversees development strategy, national accounts, design coordination, and market expansion. He brings over 20 years of hospitality development and architectural design experience, having led prototype design and franchise development for Choice Hotels International and worked with major brands including Marriott, Hilton, and InterContinental. Isaac is also the President and CEO of Extended Hospitality Group. He holds a B.S. in Architectural Design Engineering from Grambling State University.",
  },
  {
    name: "Frank W. Lawrence Jr.",
    role: "Director of Engineering & Construction",
    bio: "Frank Lawrence leads PadSite’s engineering and construction coordination, drawing on more than 35 years of civil engineering and construction management experience. His diverse career spans site development, cost control, major utility relocations for Atlanta’s I-75/I-85 Connector, construction oversight for nuclear reactors, and residential development. Frank holds a B.S. in Civil Engineering with an emphasis in Construction Management from Clemson University.",
  },
  {
    name: "Andre Thompson",
    role: "Director of Design & Brand Experience",
    bio: "Andre Thompson directs concept design and brand experience, translating client brand standards into physical, customer-facing architectural environments. His multidisciplinary career spans hospitality, restaurant, retail, and visual identity projects across the U.S. and the Caribbean, including design work for Checkers and custom installations for Kellogg's and VCU. Andre earned his BFA in Fashion Illustration from Virginia Commonwealth University.",
  },
  {
    name: "Cheri Dixon",
    role: "Director of Hospitality Strategy & Operations",
    bio: "Cheri Dixon brings over 30 years of experience in restaurant operation, venue launches, licensing, and commercial real estate development across Georgia, Texas, California, and Missouri. At PadSite, she provides an operator’s perspective to ensure projects are designed for maximum operational efficiency, managing tenant planning, compliance, and launch readiness. Cheri holds a B.A. in Public Relations from USC and is a licensed Georgia real estate agent.",
  },
  {
    name: "Lee Shands",
    role: "Director of Municipal & Real Estate Partnerships",
    bio: "Lee Shands leads outreach to local governments, economic development organizations, property owners, and commercial brokerages to advance PadSite location pipelines. He brings extensive program management experience from complex enterprise environments, including over a decade at UnitedHealth Group managing large-scale stakeholder, budget, and operational initiatives.",
  },
  {
    name: "Ken “Kenny” Howard",
    role: "Director of Building Technology & Systems",
    bio: "Kenny Howard brings 24 years of electrical and low-voltage engineering experience to PadSite, leading building technology and systems integration. He has served as Technology Lead on major commercial, healthcare, and hospitality developments for clients including Marriott, Ritz-Carlton, Mailchimp, Honeywell, and the Atlanta Braves. Kenny holds B.S. degrees in Electrical Engineering and Mathematics and maintains a Georgia Low Voltage Unrestricted License.",
  },
  {
    name: "Edmund X. “Ed” Peters",
    role: "Director of Technology & Infrastructure",
    bio: "Ed Peters leads PadSite’s enterprise technology, infrastructure, and cybersecurity strategy. His career includes senior technology and security leadership roles with the City of Atlanta, MARTA, BellSouth, and Lockheed Missiles & Space Company. Ed holds degrees in Electrical Engineering and Physics from Tuskegee University, a Master’s in Information Systems Assurance and Security, and holds CISSP, CISM, CISA, and PMP certifications.",
  },
  {
    name: "Derrick Gilbert",
    role: "Director of Capital Strategy & Business Development",
    bio: "Derrick Gilbert drives capital fundraising, strategic partnerships, and business expansion. He brings over 20 years of experience across real estate, finance, and operations, with specialized expertise in container-based development and sustainable housing through his leadership with Bahx Technologies. Derrick connects PadSite’s modular platform with domestic and international investment networks.",
  },
];

const EMERGING_TEAM = [
  {
    name: "Curtis Dilworth IV",
    role: "Marketing & Development Associate",
    bio: "A fourth-generation construction professional, Curtis Dilworth IV supports digital marketing, brand growth, and project development initiatives. He brings hands-on field experience alongside practical expertise in social media strategy and digital branding for clients across multiple sectors. Curtis is currently pursuing a B.S. in Business Administration in Entrepreneurship at Georgia State University.",
  },
];

const initials = (name) =>
  name
    .replace(/[“”"][^“”"]*[“”"]/g, "")
    .split(/\s+/)
    .filter((w) => !/^(jr\.?|sr\.?|iv|iii|ii)$/i.test(w))
    .filter((w) => w.replace(/[^A-Za-z]/g, "").length > 1)
    .map((w) => w.replace(/[^A-Za-z]/g, "")[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

const slug = (name) => name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

function TeamCard({ member }) {
  return (
    <div
      className="p-6 md:p-8 flex flex-col"
      style={{ backgroundColor: "#FFFFFF", border: "1px solid #E8E9EC" }}
      data-testid={`team-member-${slug(member.name)}`}
    >
      <div
        className="w-12 h-12 flex items-center justify-center font-bold text-sm tracking-wide flex-shrink-0"
        style={{ backgroundColor: "#2d2d2d", color: "#d4782f", fontFamily: "'Space Grotesk', sans-serif" }}
      >
        {initials(member.name)}
      </div>
      <h3 className="text-xl font-bold tracking-tight mt-5" style={{ color: "#1A1D23" }}>
        {member.name}
      </h3>
      <p className="text-xs uppercase tracking-[0.18em] font-semibold mt-1.5 mb-4" style={{ color: "#d4782f" }}>
        {member.role}
      </p>
      <p className="text-sm leading-relaxed" style={{ color: "#4A4F5C" }}>
        {member.bio}
      </p>
    </div>
  );
}

export default function AboutPage() {
  return (
    <div>
      {/* Hero - White Background */}
      <section
        data-testid="about-hero"
        style={{ backgroundColor: "#FAFAFA" }}
      >
        <div className="w-full max-w-screen-2xl mx-auto px-6 md:px-12 lg:px-24 pt-28 pb-14 md:py-20">
          <div className="max-w-4xl">
            <p
              className="text-xs uppercase tracking-[0.25em] font-semibold mb-6 opacity-0 animate-fade-up"
              style={{ color: "#d4782f" }}
            >
              About PadSite Partners
            </p>
            <h1
              className="text-3xl sm:text-5xl lg:text-6xl font-bold tracking-tighter leading-[1.08] mb-6 opacity-0 animate-fade-up animate-delay-1"
              style={{ color: "#1A1D23" }}
            >
              We Build Income-Generating Spaces.
            </h1>
            <p
              className="text-base md:text-lg leading-relaxed max-w-2xl opacity-0 animate-fade-up animate-delay-2"
              style={{ color: "#4A4F5C" }}
            >
              45 years of construction experience. 105 hospitality builds. A
              modular platform engineered for speed, certainty, and lender
              confidence.
            </p>
          </div>
        </div>
      </section>

      {/* Full-width image band */}
      <section style={{ backgroundColor: "#F4F5F7" }}>
        <div className="w-full max-w-screen-2xl mx-auto px-6 md:px-12 lg:px-24 py-12 md:py-14">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="relative overflow-hidden" style={{ maxHeight: "360px" }}>
              <img
                src={UNIT_RENDER}
                alt="The Vegan Burgler branded PadSite kitchen serving students at Florida A&M University"
                className="w-full h-full object-cover"
                data-testid="about-image-render"
              />
            </div>
            <div className="relative overflow-hidden" style={{ maxHeight: "360px" }}>
              <img
                src={INTERIOR_STOVES}
                alt="Oops Where Are My Fingers branded PadSite kitchen serving students at Morehouse College"
                className="w-full h-full object-cover"
                data-testid="about-image-interior"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section
        data-testid="about-mission"
        style={{ backgroundColor: "#2d2d2d" }}
      >
        <div className="w-full max-w-screen-2xl mx-auto px-6 md:px-12 lg:px-24 py-12 md:py-16">
          <div className="max-w-3xl">
            <p
              className="text-xs uppercase tracking-[0.25em] font-semibold mb-6"
              style={{ color: "#d4782f" }}
            >
              Our Mission
            </p>
            <h2
              className="text-3xl md:text-4xl font-bold tracking-tight leading-[1.2] mb-6"
              style={{ color: "#FFFFFF" }}
            >
              Precision-Built Spaces That Generate Returns.
            </h2>
            <p
              className="text-base md:text-lg leading-relaxed"
              style={{ color: "rgba(255, 255, 255, 0.65)" }}
            >
              We bridge the gap between landowners seeking passive income and
              restaurant operators seeking speed to market. Our modular,
              insurance-ready platform eliminates construction uncertainty and
              delivers bankable outcomes.
            </p>
          </div>
          <div className="mt-10 md:mt-12 overflow-hidden">
            <img
              src="/images/about-university-foodcourt.webp"
              alt="University Food Court — PadSite container kitchens with rooftop decks, string lights, and students dining at dusk"
              className="w-full h-auto block"
              loading="lazy"
              data-testid="about-mission-image"
            />
          </div>
        </div>
      </section>

      {/* Our Team */}
      <section data-testid="about-team" style={{ backgroundColor: "#F4F5F7" }}>
        <div className="w-full max-w-screen-2xl mx-auto px-6 md:px-12 lg:px-24 py-12 md:py-16">
          <div className="max-w-3xl mb-10 md:mb-12">
            <p
              className="text-xs uppercase tracking-[0.25em] font-semibold mb-6"
              style={{ color: "#d4782f" }}
            >
              Leadership
            </p>
            <h2
              className="text-3xl md:text-4xl font-bold tracking-tight leading-[1.2]"
              style={{ color: "#1A1D23" }}
            >
              Our Team
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {TEAM.map((member) => (
              <TeamCard key={member.name} member={member} />
            ))}
          </div>

          <div className="mt-12 md:mt-14">
            <p
              className="text-xs uppercase tracking-[0.25em] font-semibold mb-6"
              style={{ color: "#d4782f" }}
            >
              Professional / Emerging Leadership
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {EMERGING_TEAM.map((member) => (
                <TeamCard key={member.name} member={member} />
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
